export type Bucket = 'day' | 'week' | 'month'

const parse = (iso: string) => new Date(`${iso}T00:00:00`)
const dayShort = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' })
const dayLong = new Intl.DateTimeFormat(undefined, {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
})
const monthShort = new Intl.DateTimeFormat(undefined, { month: 'short' })
const monthLong = new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' })
const year = new Intl.DateTimeFormat(undefined, { year: 'numeric' })

/** A period's axis label: "Oct 12" for days and weeks (the week's Monday), "Oct" for months. */
export function axisLabel(bucket: Bucket, start: string) {
  return bucket === 'month' ? monthShort.format(parse(start)) : dayShort.format(parse(start))
}

/** A period in full, for tooltips and tables: "Mon, Oct 12, 2026", "Oct 12 – Oct 18, 2026", "October 2026". */
export function periodLabel(bucket: Bucket, start: string, end: string) {
  if (bucket === 'day') return dayLong.format(parse(start))
  if (bucket === 'month') return monthLong.format(parse(start))
  return `${dayShort.format(parse(start))} – ${dayShort.format(parse(end))}, ${year.format(parse(end))}`
}

/** "since Oct 12" / "since July 2026", for a change over the range. */
export function sinceLabel(bucket: Bucket, start: string) {
  return bucket === 'month' ? monthLong.format(parse(start)) : dayShort.format(parse(start))
}
